import React from 'react';
import PropTypes from 'prop-types';

import QuizInstruction from './components/QuizInstruction';
import QuizForm from './components/QuizForm';

class RegistrationQuiz extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.object,
    }).isRequired,
  };

  state = {
    quizStarted: false,
    language: 'english',
  };

  render() {
    if (!this.state.quizStarted) {
      return (
        <QuizInstruction
          candidateId={this.props.match.params.registrationId}
          startQuiz={({ language }) => {
            this.setState({
              quizStarted: true,
              language,
            });
          }}
        />
      );
    }
    return (
      <QuizForm
        language={this.state.language}
        candidateId={this.props.match.params.registrationId}
      />
    );
  }
}

export default RegistrationQuiz;



// WEBPACK FOOTER //
// ./src/pages/RegistationQuiz/RegistrationQuiz.js